<template>

    <!-- Foreground content -->
    <div id="search-bar" class="relative z-20 flex flex-col items-center">

        <!-- Search container with relative positioning -->
        <!-- <div class="w-5/6 2xl:w-4/6 pt-[3.7vh] mx-auto relative"> -->
        <div class="w-[90vw] sm:w-[75vw] 2xl:w-[67vw] pt-[3.7vh] mx-auto relative">

            <!-- Search input wrapper -->
            <div class="relative flex items-center">
                <!-- Search wrapper -->
                <!-- !Important
                        0_0_20px_10px: means offset-x: 0, offset-y: 0, blur: 20px and spread radius: 10px
                        spread radius: makes the shadow more intense and uniform around the element. 
                    -->
                    <!-- class="2xl:h-20 3xl:h-[88px] px-4 relative flex w-full items-center bg-white bg-opacity-80 shadow-[0_0_10px_1px_rgba(0,0,0,0.3)] shadow-gray-300 border-gray-200 rounded-xl border-y border-l"> -->
                <div
                    class="h-[8vh] px-[1.5vh] relative flex w-full items-center bg-white bg-opacity-80 shadow-[0_0_10px_1px_rgba(0,0,0,0.3)] shadow-gray-300 border-gray-200 rounded-xl border-y border-l">
                    <!-- Search components inner wrapper -->
                    <div
                        class="relative flex w-full items-center shadow-[0_0_20px_1px_rgba(0,0,0,0.3)] shadow-gray-200 rounded-2xl">
                        <!-- Search button -->
                            <!-- <button class="2xl:h-12 3xl:h-14 z-0 pl-5 pr-4 text-tethys-blue2-dark rounded-s-lg bg-white" -->
                        <button class="h-[5vh] z-0 pl-5 pr-4 text-tethys-blue2-dark rounded-s-lg bg-white"
                            @click="search()" :title="$t('search')">
                            <i class="fas fa-search text-2xl"></i>
                        </button>
                        <!-- Separator -->
                        <!-- <span class="flex items-center 2xl:h-12 3xl:h-14 bg-white"> -->
                        <span class="flex items-center h-[5vh] bg-white">
                            <span class="h-3/4 border-r-2 border-gray-200 "></span>
                        </span>
                        <!-- Input field for search query -->
                        <!-- class="2xl:h-12 3xl:h-14 w-full py-2.5 text-gray-700 placeholder-gray-400 border-none focus:ring-0 focus:outline-none rounded-e-xl" -->
                        <input id="search_query" v-model="display"
                            class="h-[5vh] w-full py-2.5 text-gray-700 placeholder-gray-400 text-sm sm:text-xs lg:text-sm xl:text-base border-none focus:ring-0 focus:outline-none rounded-e-xl"
                            type="text" name="q" autocomplete="off" v-bind:placeholder="placeholder"
                            @input="searchChanged" @keydown.down="onArrowDown" @keydown.up="onArrowUp"
                            @keydown.enter="onEnter" @keydown.tab="close" @focus="focus" />
                        <!-- Clear Button (appears only when input is not empty) -->
                        <button v-if="display"
                            class="absolute right-2 px-4 py-2 border-x-2 border-y-2 text-xs lg:text-sm xl:text-base border-gray-100 text-gray-400 hover:bg-gray-200 "
                            @click="clearSearch()" :title="$t('clean_search_bar')">
                            <i class="fas fa-times"></i>
                        </button>
                    </div>

                </div>

                <!-- Search button -->
                <!-- <button class="z-0 px-4 py-2.5 bg-secondary-tethys hover:bg-teal-500 text-white rounded-e-md border border-[#02609a] shadow-lg" @click="search()" :title="$t('search')">
                    <i class="fas fa-search"></i>
                </button> -->

            </div>

            <!-- Suggestions list -->
            <div class="absolute w-full z-50 border-x-8 border-transparent">
                <!-- <ul v-show="showResults" class="absolute left-3 right-3 bg-gray-200 bg-opacity-80 border border-gray-300 rounded-b-lg max-h-[198px] overflow-y-auto shadow-xl"> -->
                <ul v-show="showResults"
                    class="bg-tethys-blue1-light bg-opacity-70 border-b border-x border-gray-300 rounded-b-lg max-h-[198px] overflow-y-auto shadow-xl w-full">

                    <!-- Loading indicator -->
                    <li v-if="isLoading" class="p-2 text-gray-500">Loading results...</li>
                    <!-- Iterating over suggestions -->
                    <li v-for="(result, i) in suggestions" v-else v-bind:key="i" v-bind:ref="setItemRef"
                        class="py-0.5 lg:py-1 px-3 cursor-pointer hover:bg-tethys-blue1-dark hover:text-white"
                        v-bind:class="{ 'bg-teal-200': isSelected(i) }" @click.prevent="select(result)">
                        <!-- Displaying suggestion result -->
                        <div class="text-sm sm:text-xs lg:text-sm">
                            <label v-html="formatSuggestion(result)"></label>
                        </div>
                    </li>
                </ul>
            </div>

            <!-- Buttons container -->
            <div v-if="!showResults" class="flex space-x-2 mt-3.5 mr-2">
                <!-- Submit data Button -->
                <!-- <button @click="openLoginModal"
                    class="w-24 sm:w-28 lg:w-32 2xl:w-40 bg-tethys-blue1-dark hover:bg-tethys-7 text-white font-bold text-xs xl:text-sm 2xl:text-base py-2.5 rounded-lg shadow-lg">
                    {{ $t('submit') }}
                </button> -->

                <!-- START MAP Button -->
                <router-link to="/search"
                    class="h-8 2xl:h-10 3xl:h-11 w-16 md:w-20 lg:w-24 2xl:w-28 3xl:w-30 bg-tethys-blue1-dark hover:bg-tethys-7 text-white font-bold text-xs xl:text-sm 2xl:text-base py-2.5 rounded-lg shadow-lg flex items-center justify-center"
                    @click="clearSearch()"
                >
                    {{ $t('start') }}
                </router-link>
                <!-- OPEN MAP Button -->
                <!-- This button and the map search funtion will be hidden for mobile devices. -->
                <router-link to="/map"
                    class="hidden md:flex h-8 2xl:h-10 3xl:h-11 w-16 md:w-20 lg:w-24 2xl:w-28 3xl:w-30 bg-tethys-green-dark hover:bg-tethys-7 text-white font-bold text-xs xl:text-sm 2xl:text-base py-2.5 rounded-lg shadow-lg items-center justify-center">
                    {{ $t('map') }}
                </router-link>
            </div>
            
        </div>

    </div>


    <!-- LOGIN/SUBMIT MODAL -->
    <!-- <div v-if="isShowLoginModal" @click.self="closeLoginModal" -->
    <div v-if="isShowLoginModal" @click.self="closeLoginModal"
        class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm px-4"
        aria-hidden="true"
    >
        <div class="relative w-11/12 sm:w-4/5 2xl:w-3/4 max-h-screen bg-white rounded-md shadow-xl overflow-y-auto">

            <!-- Tabs Header -->
            <div class="flex border-b border-gray-200">

                <!-- ENABLE WHEN LOGIN IS READY ==================================== -->

                <!-- <button @click="activeTab = 'login'" :class="[
                        'w-1/2 text-sm font-semibold py-3 text-center transition-colors',
                        activeTab === 'login' ? 'border-b-2 border-tethys-blue1-dark text-tethys-blue1-dark bg-white' : 'bg-gray-50 text-gray-400'
                    ]">
                        Login
                    </button> -->

                <!-- TEMPORARY: Access to the old backend site ================================= -->
                <a @click="closeLoginModal" :class="
                        'w-1/2 text-sm font-semibold py-2 text-center transition-colors bg-gray-50 text-gray-400'
                    " v-bind:href="portal" target="_blank">
                    {{ $t("login") }}
                </a>
                <!-- ============================================================================ -->

                <button @click="activeTab = 'submit'" :class="[
                    'w-1/2 text-sm font-semibold py-2 text-center transition-colors',
                    activeTab === 'submit' ? 'border-b-2 border-tethys-blue1-dark text-tethys-blue1-dark bg-white' : 'bg-gray-50 text-gray-400'
                ]">
                    {{ $t("submit") }}
                </button>
            </div>

            <!-- Submit Tab Content -->
            <div v-if="activeTab === 'submit'" class="p-8 text-xs 2xl:text-sm text-gray-700 leading-relaxed">

                <!-- Links list -->
                <div class="">

                    <!-- Submission -->
                    <div class="mb-5">
                        <span class="text-tethys-blue1-dark font-bold text-base 2xl:text-lg">
                            {{ $t('loginPage.submission.title') }}
                        </span>
                        <p class="my-2" v-html="getSanitizedTextWithLinks('loginPage.submission.text')"></p>
                    </div>

                    <!-- Before publishing -->
                    <div class="mb-4">
                        <span class="text-tethys-blue1-dark font-bold text-sm 2xl:text-base">
                            {{ $t('loginPage.beforePublishing.title') }}
                        </span>
                        <p class="my-2" v-html="getSanitizedTextWithLinks('loginPage.beforePublishing.text')"></p>
                        <p class="italic text-gray-400 text-xs">[noch in Bearbeitung]</p>
                    </div>

                    <!-- Submit data -->
                    <div class="mb-4">
                        <span class="text-tethys-blue1-dark font-bold text-sm 2xl:text-base">
                            {{ $t('loginPage.submitData.title')}}
                        </span>
                        <p class="my-2">{{ $t('loginPage.submitData.text') }}</p>
                        <p class="italic text-gray-400 text-xs">[noch in Bearbeitung]</p>
                    </div>

                    <!-- Workflow -->
                    <div class="mb-4">
                        <span class="text-tethys-blue1-dark font-bold text-sm 2xl:text-base">
                            {{ $t('loginPage.workflow.title') }}
                        </span>
                        <p class="my-2" v-html="getSanitizedTextWithLinks('loginPage.workflow.text')"></p>
                        <p class="italic text-gray-400 text-xs">[noch in Bearbeitung]</p>
                    </div>

                    <!-- Login -->
                    <div class="mb-4">
                        <span class="text-tethys-blue1-dark font-bold text-sm 2xl:text-base">
                            {{ $t('loginPage.signup.title') }}
                        </span>
                        <p class="italic text-gray-400 text-xs my-1">[noch in Bearbeitung]</p>
                    </div>


                </div>

                <!-- Button -->
                <div class="mt-8 text-center">

                    <!-- ENABLE WHEN LOGIN IS READY ===================================================================  -->

                    <!-- <button @click="activeTab = 'login'"
                        class="w-full sm:w-auto px-6 py-2.5 text-sm font-semibold bg-tethys-blue2-dark text-white rounded-md shadow hover:bg-tethys-blue1-dark transition">
                        Zum Login
                    </button> -->

                    <!-- TEMPORARY: Access to the old backend site =========================== -->
                    <a @click="closeLoginModal" v-bind:href="portal" target="_blank"
                        class="flex w-full justify-center sm:w-auto px-6 py-2 text-sm font-semibold bg-tethys-blue1-dark text-white rounded-md shadow hover:bg-tethys-7 transition">
                        <strong>{{ $t("login") }}</strong>
                    </a>
                    <!-- ============================================================================ -->

                </div>
            </div>

            <!-- Login Tab Content (placeholder for now) -->
            <div v-else class="p-8 text-center text-gray-500">
                <p class="text-sm">Login form goes here.</p>
            </div>

            <!-- Close button top-right -->
            <button @click="closeLoginModal" class="absolute top-2 right-3 text-gray-400 hover:text-gray-700 transition"
                aria-label="Close">
                <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd"
                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                        clip-rule="evenodd" />
                </svg>
            </button>

        </div>
    </div>

</template>

<script lang="ts">
// import heromap from "../hero-map/Heromap2";
import VsInput from "./vs-input";
export default VsInput;
</script>


<style lang="scss" scoped>
// .columns:not(:last-child) {
//     margin-bottom: calc(1.5rem - 0.75rem);
//     display: flex;
// }

// .search-banner {
//     background-image: url('/src/assets/site/img/hero_image_static3.png');
// }

.main-search-from-bg {
    background-color: #fff;
    padding: 0.2em;
}

.column {
    display: block;
    // flex-basis: 0;
    // flex-grow: 1;
    // flex-shrink: 1;
    /* padding: 0.75rem; */
    position: relative;
    padding: 0;
}

.button {
    background-color: #33cccc;
    // border-color: #dbdbdb;
    border-width: 0;
    color: #363636;
    cursor: pointer;
    justify-content: center;
    padding-bottom: 0;
    padding-left: 1em;
    padding-right: 1em;
    padding-top: 0;
    text-align: center;
    white-space: nowrap;
}

.search-box {
    background-image: url(./../../assets/site/img/white-pixel.png);
    background-repeat: repeat;
    padding: 1.8em;
    // width: 28em;
}

.control .input,
.control .input:focus,
.column .input.selected {
    // background-color: white;
    /* border-color: #dbdbdb; */
    // border: 0;
    // outline: none;
    border-radius: 4px;
    color: #363636;
}

input {
    border-width: 0;
    box-shadow: none;
}

.autocomplete-results {
    padding: 0;
    margin: 0;
    margin-left: 0em;
    border: 1px solid #eeeeee;
    list-style-type: none;
    z-index: 1000;
    position: absolute;
    max-height: 192px;
    overflow-y: auto;
    overflow: hidden;
    background: white;
    width: 100%;
    border: 1px solid #ccc;
    border-top: 0;
    color: black;
}

.autocomplete-result-item {
    list-style: none;
    text-align: left;
    padding: 0px 0px 0px 5px; // top,right,bottom,left
    cursor: pointer;
}

.autocomplete-result-item.is-active {
    background: rgba(0, 180, 255, 0.15);
    // background: #3cc;
}

.autocomplete-result-item:hover {
    // background: rgba(0, 180, 255, 0.075);
    background: #baedf1;
}
</style>
